/** @jsx jsx */
import { jsx } from "theme-ui";

const styleMainMdx = {
  display: "flex",
  flexGrow: 1,
  flexDirection: "column",
  width: "100%",
  justifyContent: "flex-start",
  position: "relative",

  py: [0, 2],
  my: [0, 2],
  px: [1, 2],

};


const LayoutMdxMainCols = (props) => {

  const { children, _frontmatter, ...rest } = props
  // const { contentDir, sectionLMR, sectionFullDown } = _frontmatter

  return (
    <div
      sx={styleMainMdx} id="layoutMdxMainCols">
      {children}
    </div>
  );
};

export default LayoutMdxMainCols;
